import { gql } from '@apollo/client'

export const ASSIGN_GOALS_TO_GOAL_GROUP = gql`
  mutation AssignGoalsToGoalGroup($data: AssignGoalsToGoalGroupInput!) {
    assignGoalsToGoalGroup(data: $data) {
      count
    }
  }
`
